import React from 'react';

import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { createReactRenderer } from '../helpers/react-renderer';

import { UnstyledButton } from './SerializedRefundModal.style';
import { SerializedItem } from './types';
import { getAllSelectedSerials } from './utils';

const SerializedRefundSelectedLines = ({
  refundLineID,
  originalTransactionLineID,
  quantityOut,
}: {
  refundLineID: number;
  originalTransactionLineID: number;
  quantityOut: number;
}) => {
  const [listOfSelectedSerials, setListOfSelectedSerials] = React.useState<SerializedItem[]>([]);

  React.useEffect(() => {
    const serializedRefundElList = document.getElementsByClassName(
      'serialized-refund-transaction-line'
    );

    let serializedRefund: Record<string, any>;

    if (serializedRefundElList.length) {
      Array.from(serializedRefundElList).map(
        // eslint-disable-next-line array-callback-return, consistent-return
        (serializedRefundTransactionLine) => {
          const propsObj = JSON.parse(
            serializedRefundTransactionLine.getAttribute('data-react-props')!
          );

          if (propsObj!.transactionLineId === originalTransactionLineID)
            serializedRefund = propsObj;
        }
      );

      setListOfSelectedSerials(getAllSelectedSerials(serializedRefund!.serials));
    }
  }, [originalTransactionLineID]);

  if (!(quantityOut < 0)) {
    return null;
  }

  const handleRemove = async (serializedID: number) => {
    const listOfSelectedSerialsLength = listOfSelectedSerials.length;

    if (listOfSelectedSerialsLength > 1) {
      window.merchantos.utils.openUrl(
        `register.php?form_name=delete_serial_from_refund&transaction_line_id=${refundLineID}&serialized_id=${serializedID}`
      );
    } else if (listOfSelectedSerialsLength === 1 && refundLineID) {
      window.merchantos.register.removeLine(refundLineID);
    }
  };

  // eslint-disable-next-line consistent-return
  const renderSelectedSerialsList = () => {
    if (listOfSelectedSerials.length) {
      return listOfSelectedSerials.map(({ serial, serializedId }) => (
        <Flex key={serializedId} data-test="selected-serial-number">
          <Text className="notranslate" style={{ wordBreak: 'break-all' }}>
            {serial || 'None'} <span>/</span>
            <UnstyledButton
              style={{ fontWeight: 'normal', fontSize: '14px', marginLeft: '3px' }}
              onClick={() => handleRemove(serializedId)}
            >
              Remove
            </UnstyledButton>
          </Text>
        </Flex>
      ));
    }
  };

  return (
    <Flex
      justifyContent="center"
      flexDirection="column"
      data-test="serial-number-list"
      className="serial-number-list"
    >
      {renderSelectedSerialsList()}
    </Flex>
  );
};

export default SerializedRefundSelectedLines;

const RenderedComponent = createReactRenderer({
  component: SerializedRefundSelectedLines,
  selector: '[data-react-root="SerializedRefundSelectedLines"]',
});

history.onChangeState(
  [
    { pathname: '/register.php', form_name: undefined },
    { pathname: '/register.php', form_name: 'load_refund' },
    { pathname: '/register.php', form_name: 'change_view' },
    { form_name: 'refund_transaction_line' },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
